import { handleError, setAuthorization } from '../utils/axiosConfig';

export default function ({ store, app: { $axios } }) {
  $axios.onRequest((config) => {
    if (config.headers.common) {
      config.headers.common['Experience'] = store.getters['experience/getExperience'];
      config.headers.common['Accept-Language'] = store.$i18n.locale;
      setAuthorization(process.server, config, store.$cookies);
    }
  });

  $axios.onError((error) =>
    handleError(error, store.$cookies, store.dispatch, process.env.COOKIES_DOMAIN)
  );
}
